<template>
  <main>
    <!-- Hero area start here -->
    <HomeSwiper />
    <!-- Banner area end here -->

    <!-- 产品列表 -->
    <h2
      class="wow fadeInUp w-[100%] text-center mt-[50px]"
      data-wow-duration="1.2s"
      data-wow-delay=".2s"
    >
      {{ $t("55i16k") }}
    </h2>
    <section class="blog-two view-area pb-50 pt-35">
      <div class="container">
        <div class="row g-4">
          <div
            class="col-lg-4 col-md-6 wow fadeInDown"
            data-wow-duration="1.2s"
            data-wow-delay=".2s"
            v-for="(item, index) in productData"
            :key="index"
          >
            <router-link :to="localePath(`/products/detail/${item.pageId}`)">
              <div class="donation__item blog-two__item bor view__item">
                <div class="blog-two__image mb-30">
                  <div class="image h-60 w-full overflow-hidden">
                    <img
                      :src="item.avatar"
                      alt="image"
                      class="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <h3><a :href="localePath(`/products/detail/${item.pageId}`)">{{ item.title[locale] }}</a></h3>
                <a :href="localePath(`/products/detail/${item.pageId}`)"><i class="fa-solid fa-arrow-right"
                    style="color: var(--primary-color)"></i></a>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <router-link
        :to="localePath('/products/charger')"
        class="wow fadeInUp w-[100%] text-center mt-[20px] cursor-pointer"
      >
        <h5
          data-wow-duration="1.2s"
          data-wow-delay=".2s"
          style="color: var(--primary-color)"
        >
          {{ $t("46knqz") }}
        </h5>
      </router-link>
    </section>
    <!-- View area end here -->

    <!-- 关于我们 -->
    <section class="involve-two sub-bg pt-130 pb-130">
      <div class="container">
        <div class="row g-4 align-items-center">
          <div class="col-xl-5">
            <div class="involve-two__image">
              <img
                src="/assets/images/about/about-five-image.png"
                alt="image"
              />
              <!-- <div class="image-sm">
                                <img src="/assets/images/involve/involve-sm.jpg" alt="image">
                            </div> -->
            </div>
          </div>
          <div class="col-xl-6">
            <div class="involve-two__item">
              <div class="section-header mb-4">
                <h5
                  class="wow fadeInUp"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  {{ $t("3kc6tv") }}
                </h5>
                <h2
                  class="wow fadeInUp"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  {{ $t("6qcvmt") }}
                </h2>
                <p
                  class="wow fadeInUp"
                  data-wow-duration="1.6s"
                  data-wow-delay=".6s"
                >
                  {{ $t("q4gl8m") }}
                </p>
              </div>
              <div class="accordion" id="accordionExample-two">
                <div
                  class="accordion-item wow fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  <h2 class="accordion-header" id="heading1">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse1"
                      aria-expanded="true"
                      aria-controls="collapse1"
                    >
                      {{ $t("0bkzav") }}
                    </button>
                  </h2>
                  <div
                    id="collapse1"
                    class="accordion-collapse collapse show"
                    aria-labelledby="heading1"
                    data-bs-parent="#accordionExample-two"
                  >
                    <div class="accordion-body">
                      <p>{{ $t("1evpyn") }}</p>
                    </div>
                  </div>
                </div>
                <div
                  class="accordion-item bor-top wow fadeInDown"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  <h2 class="accordion-header" id="heading2">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse2"
                      aria-expanded="false"
                      aria-controls="collapse2"
                    >
                      {{ $t("5zffxf") }}
                    </button>
                  </h2>
                  <div
                    id="collapse2"
                    class="accordion-collapse collapse"
                    aria-labelledby="heading2"
                    data-bs-parent="#accordionExample-two"
                  >
                    <div class="accordion-body">
                      <p>{{ $t("ylce9w") }}</p>
                    </div>
                  </div>
                </div>
                <div
                  class="accordion-item wow fadeInDown"
                  data-wow-duration="1.6s"
                  data-wow-delay=".6s"
                >
                  <h2 class="accordion-header" id="heading3">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse3"
                      aria-expanded="false"
                      aria-controls="collapse3"
                    >
                      {{ $t("z9sirx") }}
                    </button>
                  </h2>
                  <div
                    id="collapse3"
                    class="accordion-collapse collapse"
                    aria-labelledby="heading3"
                    data-bs-parent="#accordionExample-two"
                  >
                    <div class="accordion-body">
                      <p>{{ $t("ztmq69") }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <a :href="localePath('/about')" class="btn-one mt-35"
                ><span>{{ $t("4y6126") }}</span>
                <i class="fa-solid fa-angles-right"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- About area end here -->

    <!-- Work area start here -->
    <section class="work work-five pt-130 pb-65">
      <div class="container">
        <div class="pb-65 bor-bottom mb-65">
          <div class="row g-5 align-items-center">
            <div class="col-lg-6">
              <div class="section-header m-0">
                <h5
                  class="wow fadeInUp"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  {{ $t("x0zeot") }}
                </h5>
                <h2
                  class="wow fadeInUp"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  {{ $t("l4w4k5") }}
                </h2>
              </div>
            </div>
            <div class="col-lg-6">
              <div
                class="work-five__head-image wow fadeInUp float-start float-lg-end"
                data-wow-duration="1.6s"
                data-wow-delay=".6s"
              >
                <img src="/assets/images/work/how-image1.png" alt="image" />
              </div>
            </div>
          </div>
        </div>
        <div class="row g-4">
          <div
            class="col-xxl-4 col-xl-4 col-lg-8 col-md-8 wow fadeInDown"
            data-wow-duration="1.2s"
            data-wow-delay=".2s"
          >
            <router-link to="/solutions/battery-swap">
              <div class="work-five__item">
                <div class="work__item-icon mb-30">
                  <img
                    :src="solutionAvatar['solution-battery']"
                    class="w-[320px] rounded-[6px]"
                    alt="image"
                  />
                  <span class="ml-[10px]">01</span>
                </div>
                <h3>
                  <a>{{ $t("b0hs5p") }}</a>
                </h3>
                <a
                  ><i
                    class="fa-solid fa-arrow-right"
                    style="color: var(--primary-color)"
                  ></i
                ></a>
              </div>
            </router-link>
          </div>
          <div
            class="col-xxl-4 col-xl-4 col-lg-8 col-md-8 wow fadeInDown"
            data-wow-duration="1.4s"
            data-wow-delay=".4s"
          >
            <router-link to="/solutions/charging-station">
              <div class="work-five__item">
                <div class="work__item-icon mb-30">
                  <img
                    :src="solutionAvatar['solution-charge']"
                    class="w-[320px] rounded-[6px]"
                    alt="image"
                  />
                  <span class="ml-[10px]">02</span>
                </div>
                <h3>
                  <a>{{ $t("c2ez5z") }}</a>
                </h3>
                <a
                  ><i
                    class="fa-solid fa-arrow-right"
                    style="color: var(--primary-color)"
                  ></i
                ></a>
              </div>
            </router-link>
          </div>
          <div
            class="col-xxl-4 col-xl-4 col-lg-8 col-md-8 wow fadeInDown"
            data-wow-duration="1.6s"
            data-wow-delay=".6s"
          >
            <router-link to="/solutions/battery-swap">
              <div class="work-five__item">
                <div class="work__item-icon mb-30">
                  <img
                    :src="solutionAvatar['solution-save-take']"
                    class="w-[320px] rounded-[6px]"
                    alt="image"
                  />
                  <span class="ml-[10px]">03</span>
                </div>
                <h3>
                  <a>{{ $t("c0ktoq") }}</a>
                </h3>
                <a
                  ><i
                    class="fa-solid fa-arrow-right"
                    style="color: var(--primary-color)"
                  ></i
                ></a>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- Work area end here -->

    <!-- achievement area start here -->
    <section class="achievement-five">
      <div class="container">
        <div
          class="achievement-five__wrp bg-image"
          data-background="/assets/images/bg/achievement-bg.jpg"
        >
          <div class="row g-4 align-items-center justify-content-between">
            <div class="col-lg-5">
              <div class="achievement-five__item">
                <h3
                  class="wow fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  {{ $t("z6scfb") }}
                </h3>
                <a
                  @click="showContact"
                  class="btn-two-light wow fadeInUp mt-50 cursor-pointer"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                  ><span>{{ $t("5x747l") }}</span>
                  <i class="fa-solid fa-angles-right"></i
                ></a>
              </div>
            </div>
            <div
              class="col-lg-2 wow fadeInUp"
              data-wow-duration="1.2s"
              data-wow-delay=".2s"
            >
              <div class="achievement-five__count">
                <h2 class="count">200</h2>
                <h5>{{ $t("bf3yap") }}</h5>
              </div>
            </div>
            <div
              class="col-lg-2 wow fadeInUp"
              data-wow-duration="1.4s"
              data-wow-delay=".4s"
            >
              <div class="achievement-five__count">
                <div class="flex items-center">
                  <h2 class="count">30</h2>
                  <h2>+</h2>
                </div>
                <h5>{{ $t("jw5v3a") }}</h5>
              </div>
            </div>
            <div
              class="col-lg-2 wow fadeInUp"
              data-wow-duration="1.6s"
              data-wow-delay=".6s"
            >
              <div class="achievement-five__count">
                <div class="flex items-center">
                  <h2 class="count">800</h2>
                  <h2>+</h2>
                </div>
                <h5>{{ $t("v7dug3") }}</h5>
              </div>
            </div>
          </div>
          <div class="achievement-five__bg-overlay">
            <img src="/assets/images/bg/achievement-bg-image.jpg" alt="image" />
          </div>
        </div>
      </div>
    </section>
    <!-- achievement area end here -->

    <!-- Project area sart here -->
    <ProjectArea />
    <!-- Project area end here -->

    <!-- Team area start here -->
    <!-- <section class="team pt-130 pb-130">
      <div class="container">
        <div class="blog__head-wrp mb-65">
          <div class="section-header m-0">
            <h5 class="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".2s">{{ $t('pfodod') }}</h5>
            <h2 class="wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".4s">The amazing team behind <br>
              our company</h2>
          </div>
          <div class="arry-btn mt-4 mt-lg-0">
            <button class="arry-prev team__arry-prev wow fadeInUp" data-wow-duration="1.6s" data-wow-delay=".6s"><i
                class="fa-light fa-chevron-left"></i></button>
            <button class="ms-3 active arry-next team__arry-next wow fadeInUp" data-wow-duration="1.8s"
              data-wow-delay=".8s"><i class="fa-light fa-chevron-right"></i></button>
          </div>
        </div>
        <div class="swiper team__slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="team__item">
                <div class="team__item-image">
                  <img src="/assets/images/team/team1.png" alt="image">
                  <div class="team__item-image-icon social-icon">
                    <a href="#0"><i class="fa-brands fa-facebook-f"></i></a>
                    <a href="#0"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#0"><i class="fa-brands fa-linkedin-in"></i></a>
                    <a href="#0"><i class="fa-brands fa-youtube"></i></a>
                  </div>
                </div>
                <h3><a href="team-single.html">Dana A. Hutchison</a></h3>
                <span>Founder</span>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="team__item">
                <div class="team__item-image">
                  <img src="/assets/images/team/team2.png" alt="image">
                  <div class="team__item-image-icon social-icon">
                    <a href="#0"><i class="fa-brands fa-facebook-f"></i></a>
                    <a href="#0"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#0"><i class="fa-brands fa-linkedin-in"></i></a>
                    <a href="#0"><i class="fa-brands fa-youtube"></i></a>
                  </div>
                </div>
                <h3><a href="team-single.html">Bonnie J. Britt</a></h3>
                <span>Mechanic</span>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="team__item">
                <div class="team__item-image">
                  <img src="/assets/images/team/team3.png" alt="image">
                  <div class="team__item-image-icon social-icon">
                    <a href="#0"><i class="fa-brands fa-facebook-f"></i></a>
                    <a href="#0"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#0"><i class="fa-brands fa-linkedin-in"></i></a>
                    <a href="#0"><i class="fa-brands fa-youtube"></i></a>
                  </div>
                </div>
                <h3><a href="team-single.html">Francis A. Cote</a></h3>
                <span>Car electrician</span>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="team__item">
                <div class="team__item-image">
                  <img src="/assets/images/team/team4.png" alt="image">
                  <div class="team__item-image-icon social-icon">
                    <a href="#0"><i class="fa-brands fa-facebook-f"></i></a>
                    <a href="#0"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#0"><i class="fa-brands fa-linkedin-in"></i></a>
                    <a href="#0"><i class="fa-brands fa-youtube"></i></a>
                  </div>
                </div>
                <h3><a href="team-single.html">Mario L. Lawhorn</a></h3>
                <span>Co - Founder</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- Team area end here -->

    <!-- Testimonial area start here -->
    <!-- <section class="testimonial pt-130 pb-130 sub-bg">
      <div class="container">
        <div class="testimonial__head-wrp mb-65">
          <div class="section-header m-0">
            <h5 class="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".2s"> {{ $t('opgs11') }}
            </h5>
            <h2 class="wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".4s">{{ $t('u2gxq2') }}</h2>
          </div>
          <div class="dot-wrp wow fadeInUp mt-5 mt-sm-0" data-wow-duration="1.6s" data-wow-delay=".6s">
            <div class="dot testimonial__dot"></div>
          </div>
        </div>
        <div class="swiper testimonial__slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="testimonial__item">
                <div class="testimonial__item-head">
                  <div class="testimonial__item-head-info">
                    <div class="testimonial__item-head-info-image">
                      <img src="/assets/images/testimonial/01.png" alt="image">
                    </div>
                    <div class="testimonial__item-head-info-con">
                      <h3>Kenneth S. Fisher</h3>
                      <span>Marketing Manager</span>
                    </div>
                  </div>
                  <i class="fa-solid fa-quote-right"></i>
                </div>
                <div class="testimonial__item-content">
                  <p>posuere luctus orci. Donec vitae mattis quam, vitae tempor arcu. Aenean non odio
                    porttitor, convallis erat sit amet,
                    facilisis velit. Nulla ornare convallis</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="testimonial__item">
                <div class="testimonial__item-head">
                  <div class="testimonial__item-head-info">
                    <div class="testimonial__item-head-info-image">
                      <img src="/assets/images/testimonial/02.png" alt="image">
                    </div>
                    <div class="testimonial__item-head-info-con">
                      <h3>Jennifer R. Tanaka</h3>
                      <span>Marketing Manager</span>
                    </div>
                  </div>
                  <i class="fa-solid fa-quote-right"></i>
                </div>
                <div class="testimonial__item-content">
                  <p>posuere luctus orci. Donec vitae mattis quam, vitae tempor arcu. Aenean non odio
                    porttitor, convallis erat sit amet,
                    facilisis velit. Nulla ornare convallis</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="testimonial__item">
                <div class="testimonial__item-head">
                  <div class="testimonial__item-head-info">
                    <div class="testimonial__item-head-info-image">
                      <img src="/assets/images/testimonial/01.png" alt="image">
                    </div>
                    <div class="testimonial__item-head-info-con">
                      <h3>Kenneth S. Fisher</h3>
                      <span>Marketing Manager</span>
                    </div>
                  </div>
                  <i class="fa-solid fa-quote-right"></i>
                </div>
                <div class="testimonial__item-content">
                  <p>posuere luctus orci. Donec vitae mattis quam, vitae tempor arcu. Aenean non odio
                    porttitor, convallis erat sit amet,
                    facilisis velit. Nulla ornare convallis</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- Testimonial area end here -->

    <!-- Blog area start here -->
    <section class="blog pt-130 pb-130">
      <div class="container">
        <div class="blog__head-wrp mb-65">
          <div class="section-header m-0">
            <h5
              class="wow fadeInUp"
              data-wow-duration="1.2s"
              data-wow-delay=".2s"
            >
              {{ $t("3si6ya") }}
            </h5>
            <h2
              class="wow fadeInUp"
              data-wow-duration="1.4s"
              data-wow-delay=".4s"
            >
              {{ $t("ckke19") }}
            </h2>
          </div>
          <a
            :href="localePath('/news')"
            class="btn-one mt-4 mt-md-0 wow fadeInUp"
            data-wow-duration="1.6s"
            data-wow-delay=".6s"
            ><span>{{ $t("rdvt0y") }}</span>
            <i class="fa-solid fa-angles-right"></i
          ></a>
        </div>
        <div class="row g-4 justify-content-center">
          <div
            class="col-xl-8 wow fadeInLeft"
            data-wow-duration="1.2s"
            data-wow-delay=".2s"
          >
            <div class="blog__item-left">
              <div class="swiper blog__slider">
                <div class="swiper-wrapper">
                  <router-link
                    :to="localePath(`/news/detail/${newsListData[0].pageId}`)"
                  >
                    <div class="swiper-slide">
                      <div class="row g-4">
                        <div class="col-md-5">
                          <div class="blog__item-left-content">
                            <h3>
                              <a>{{ newsListData[0].title }}</a>
                            </h3>
                            <p>{{ newsListData[0].content }}</p>
                            <!-- <span class="blog__item-left-content-info">By <strong>Max
                              Trewhitt</strong> 2
                            weeks ago</span> -->
                          </div>
                        </div>
                        <div class="col-md-7">
                          <div
                            class="image"
                            style="width: 500px; height: 500px"
                          >
                            <img
                              :src="newsListData[0].avatar"
                              alt="image"
                              style="
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="blog__item-left-dot-wrp">
                <div class="dot blog__dot"></div>
              </div>
            </div>
          </div>
          <div
            class="col-xl-4 col-lg-6 wow fadeInRight"
            data-wow-duration="1.4s"
            data-wow-delay=".4s"
          >
            <router-link
              :to="localePath(`/news/detail/${newsListData[1].pageId}`)"
            >
              <div class="blog__item-right">
                <a class="image d-block">
                  <img :src="newsListData[1].avatar" alt="image" />
                </a>
                <h3>
                  <a>{{ newsListData[1].title }}</a>
                </h3>
                <p>{{ newsListData[1].content }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- Blog area end here -->
  </main>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import HomeSwiper from "~/components/HomeSwiper.vue";
import ProjectArea from "~/components/ProjectArea.vue";
const { locale } = useI18n();
const { t } = useI18n()
const localePath = useLocalePath();
const solutionAvatar = ref({});

useHead({
  title: t("q73uuz"),
  meta: [
    {
      name: "description",
      content: t("mvht1a"),
    },
    {
      name: "keywords",
      content: t("zrb72y"),
    },
  ],
});

// product 模块
const { data: pageList } = await useFetch<any>("/sre/pages/list/public", {
  baseURL: useRuntimeConfig().public.apiUrl,
  params: {
    classify: "product",
    page: 1,
    size: 50,
  }
})
const productData = (pageList.value?.data?.list || []).map((v: any) => ({
  avatar: v.avatar[0],
  pageId: v.pageId,
  title: v.title,
})).slice(0, 3)


// news模块
const { data: newsList } = await useFetch<any>("/sre/pages/list/public", {
  baseURL: useRuntimeConfig().public.apiUrl,
  params: {
    classify: "news",
    page: 1,
    size: 50,
  },
});

// 从HTML中提取纯文本并截取前100个字符
const extractTextFromHtml = (html) => {
  if (!html) return "";

  // 使用正则表达式移除HTML标签
  const text = html
    .replace(/<[^>]*>/g, "")
    // 替换HTML实体
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    // 移除多余空格
    .replace(/\s+/g, " ")
    .trim();

  // 截取前100个字符，如果不足100个字符则返回全部
  return text.substring(0, 100) + (text.length > 100 ? "..." : "");
};

const newsListData = (newsList.value?.data?.list || []).map((v) => ({
  avatar: v.avatar[0],
  pageId: v.pageId,
  content: extractTextFromHtml(v.content[locale.value]),
  title: v.title[locale.value],
}));

// 解决方案图片
const { data: avatarList } = await useFetch<any>("/sre/pages/solution/avatar", {
  baseURL: useRuntimeConfig().public.apiUrl,
});
solutionAvatar.value = {
  "solution-charge": avatarList.value.data?.find(
    (v) => v.classify === "solution-charge"
  )?.avatar[0],
  "solution-save-take": avatarList.value.data?.find(
    (v) => v.classify === "solution-save-take"
  )?.avatar[0],
  "solution-battery": avatarList.value.data?.find(
    (v) => v.classify === "solution-battery"
  )?.avatar[0],
};
console.log("avatarList", solutionAvatar.value);

// 联系我们按钮点击事件
const showContact = () => {
  console.log("showContact");

  // 确保只在客户端执行
  if (import.meta.browser) {
    // Tawk_API.toggle();
    // // 尝试方法 2: 直接操作 iframe
    // const chatIframe = document.getElementById('s-chat-plugin')
    // console.log('聊天 iframe:', chatIframe)

    // if (chatIframe) {
    //   // 尝试方法 2.1: 尝试触发点击事件
    //   try {
    //     // 如果 iframe 和主页面同源，可以直接访问其内容
    //     const iframeDocument = chatIframe.contentDocument || chatIframe.contentWindow.document
    //     const chatButton = iframeDocument.querySelector('.view_btn_chat_pglag')

    //     if (chatButton) {
    //       console.log('在 iframe 中找到聊天按钮，尝试点击')
    //       chatButton.click()
    //       return
    //     }
    //   } catch (e) {
    //     console.log('无法访问 iframe 内容，可能是跨域限制:', e)
    //   }
    // }
  }
};
</script>

<style>
.show {
  visibility: visible;
}
</style>
